<template>
  <div class="meta-label">{{ label }}</div>
  <div class="meta-value">
    <v-tooltip location="top" open-delay="200" style="width: 20%;">
      <template #activator="{ props }">
        <div class="value-clip" v-bind="props">
          <span
            v-text="valueToShow"
            class="ellipsis"
          />
        </div>
      </template>
      <span class="tooltip-wrap">{{ valueToShow }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "AlertMetaItem",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: "-" },
    lines: { type: Number, default: 1 },
  },
  computed: {
    valueToShow() {
      if (this.value === null || this.value === undefined || this.value === "") {
        return "-";
      }
      return String(this.value);
    },
  },
};
</script>

<style scoped>
.meta-label {
  color: var(--v-theme-secondary);
  font-weight: 500;
  font-size: 0.98rem;
  white-space: nowrap;
}
.meta-value {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.value-clip {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.ellipsis {
  display: block;
  text-overflow: ellipsis;
  max-width: 20vw;
  overflow: hidden !important;
  white-space: nowrap;
}

.tooltip-wrap {
  display: inline-block;
  max-width: min(70vw, 560px);
  white-space: normal;
  word-break: break-word;
}
</style>


